import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import React, { useState, useContext, useEffect, Fragment } from 'react';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import styled from "@mui/system/styled";

import { KpiContext } from '../../context/context';
import '../../Pages/Menu/components/DesktopHome/homeInterno.scss';
import { CustomButton } from '../customButton/CustomButton';

export default function KpiDesktop() {
  const [kpiContext, setKpiContext] = useContext(KpiContext);
  const [listaKpi, setListaKpi] = useState(null);
  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
  const [loadingKpi, setLoadingKpi] = useState(false);

  const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-container": {
      alignItems: "flex-start",
      marginTop: '30px'
    }
  }));

  useEffect(() => {
    setLoadingKpi(true);
    getKpisUsuario({
      variables: { idUsuario: idUsuario }
    });
  }, [idUsuario]);

  const QGetKpisUsuario = gql`
    query QGetKpisUsuario ($idUsuario: Int!) {
        kpisUsuario (idUsuario: $idUsuario)
        {
            success,
            error,
            valorEsperado {
                nombre,
                descripcion,
                valor,
                icono,
                link,
                iframe
            }
        }
    }`;

  const [getKpisUsuario, { error: errorKPI, data: dataKpi }] = useLazyQuery(QGetKpisUsuario, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!dataKpi) return;
    if (dataKpi.kpisUsuario.success) {
      setListaKpi(dataKpi.kpisUsuario.valorEsperado);
    }
    setLoadingKpi(false);
  }, [dataKpi]);

  useEffect(() => {
    if (!errorKPI) return;
    setLoadingKpi(false);
  }, [errorKPI]);

  let kpiDetalle;
  let i = 0;
  if (listaKpi != null && listaKpi.length > 0) {
    kpiDetalle = listaKpi.map((kpi, index) => {
      { i = i + 1; }
      return (
        <Fragment key={kpi.nombre + index}>
          <div className={"home-kpi-column" + (i % 4 != 0 ? ' home-kpi-linea' : '')} title={kpi.descripcion}>
            <div className='home-kpi-column-titulo'>
              {kpi.nombre}
            </div>
            <div className='home-kpi-datos-bloque'>
              <div className='home-kpi-datos-numero'>
                {kpi.valor}
              </div>
            </div>
          </div>
        </Fragment>);

    });
  }

  const kpiSection =
    <div className='home-kpi-grilla'>
      {kpiDetalle}
    </div>;


  const handleClose = () => {
    setKpiContext('none');
  };

  return (
    <>
      <StyledDialog
        maxWidth="md"
        open={kpiContext === 'block' ? true : false}
        PaperProps={{ sx: { ml: "550px" } }}
        scroll="paper">

        <DialogTitle><div className='home-kpi-titulo'>Métricas</div></DialogTitle>
        <DialogContent style={{ width: '625px' }}>
          <div className='home-kpi-container' style={{ width: '625px' }}>
            {!loadingKpi && kpiSection}
            {loadingKpi && <div className='home-kpi-loading'><CircularProgress /></div>}
          </div>
        </DialogContent>
        <DialogActions>
          <div className='home-kpi-acciones'>
            <CustomButton
              onClick={handleClose}
              outlinedGray={true}
              size='small'
              variant='outlined'>

              Cerrar
            </CustomButton>
            {/* <Button onClick={handleClose} variant="outlined" style={{ borderColor: '#636A73', color: '#636A73'}} size='small'>
                 Cerrar
              </Button> */}
          </div>
        </DialogActions>
      </StyledDialog>
    </>);

}